export default __webpack_public_path__ + "static/media/shaft.977803ec.png";